import { render } from "./TheLanguage.vue?vue&type=template&id=b01f1d20"
import script from "./TheLanguage.vue?vue&type=script&lang=js"
export * from "./TheLanguage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/profixone-instant-clone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__